module.exports = __webpack_public_path__ + "static/media/Williams Garcia.884e9bf5.png";